import axios from '../axios'
import { USERACTIVITYROUTES } from 'src/router/Api'

export interface UserActivityParams {
	limit: number
	offset: number
	category?: string
	search_field?: string
	search_value?: string
}

export const getActiveUsers = async (params: UserActivityParams) => {
	return await axios.get(USERACTIVITYROUTES.name, {
		params,
	})
}

export const sendActiveUserEmail = async (
	userId: string,
	payload: {
		subject: string
		body: string
	},
) => {
	return await axios.post(USERACTIVITYROUTES.sendEmail(userId), payload)
}
